export const filters = [
	{
		id: "jobs",
		label: "JOBS",
	},
	{
		id: "consultants",
		label: "CONSULTANTS",
	},
];

export enum TooltipType {
	ShiftDetails = "shift-details",
	ShiftSalaryDetails = "shift-salary-details",
}
